import React from 'react';
import { Decoration, Mark } from 'slate';

import EmailHighlight from './email_highlight';
import EmailHighlightMenu from './email_highlight_menu';

export default function EmailHighlighting({ onChange }) {
  return {
    decorateNode(node, editor, next) {
      const others = next() || [];

      let decorations = [];
      const textNodes = node.getTexts();
      textNodes.forEach(textNode => {
        const emailRanges = findEmailRanges(textNode);
        emailRanges.forEach(range => {
          decorations.push(
            Decoration.create({
              anchor: {
                key: textNode.key,
                offset: range.start,
              },
              focus: {
                key: textNode.key,
                offset: range.end,
              },
              mark: Mark.create({
                type: 'emailHighlight',
                isAtomic: true,
                data: {
                  text: range.word,
                },
              }),
            })
          );
        });
      });

      return [...others, ...decorations];
    },

    renderEditor(props, editor, next) {
      const children = next();

      return (
        <React.Fragment>
          {children}
          <EmailHighlightMenu />
        </React.Fragment>
      );
    },

    renderMark(props, editor, next) {
      const { attributes, children, mark, node, offset, text } = props;

      if (mark.type === 'emailHighlight') {
        return (
          <EmailHighlight
            editor={editor}
            node={node}
            onChange={onChange}
            start={offset}
            end={offset + text.length}
            text={text}
            {...attributes}
          >
            {children}
          </EmailHighlight>
        );
      }
      return next();
    },
  };
}

function findEmailRanges(textNode) {
  const EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;
  const text = textNode.text;

  let ranges = [];
  let match = EMAIL_REGEX.exec(text);
  while (match !== null) {
    ranges.push({
      start: match.index,
      end: match.index + match[0].length,
      word: match[0],
    });
    match = EMAIL_REGEX.exec(text);
  }

  return ranges;
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/plugins/email_highlighting/email_highlighting.jsx